// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from "./Layout";
import Sentences from './Sentences';
import Words from './Words';
import { useState, useEffect } from 'react';
import Confetti from 'react-confetti';

import './App.css';
import './styles.css';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Words />} />
          <Route path="sentences" element={<Sentences />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
